import { KPOW_REQUESTS } from '../dataSource';
import type { WidgetSchema } from '../types';

export const kpowBroadcast: WidgetSchema = {
    meta: {
        id: 'kpow-broadcast',
        category: 'indices',
        categoryTitle: 'Indices',
        title: 'American Power Index (KPOW) Broadcast',
        description: 'Broadcast-styled American Power Index for 16:9 displays and on-air use.',
        status: 'live',
    },
    // Fixed 16:9 broadcast frame. BroadcastKpow contain-scales the 1280x720 design to
    // whatever size the embedder gives the iframe, so the default is the native canvas.
    fields: [
        { kind: 'theme', key: 'colorTheme', label: 'Theme', defaultValue: 'light', hidden: true },
        {
            kind: 'dimensions',
            key: 'dimensions',
            label: 'Dimensions',
            defaultValue: { width: '1280px', height: '720px' },
            fixed: { width: '1280px', height: '720px' },
            hidden: true,
        },
        {
            kind: 'utm',
            key: 'utm',
            label: 'Marketing (UTM)',
            defaultValue: { utmSource: '', utmCampaign: '', promoCode: '' },
        },
        { kind: 'boolean', key: 'showBorder', label: 'Border', defaultValue: false },
        { kind: 'boolean', key: 'rounded', label: 'Rounded corners', defaultValue: false },
    ],
    preview: { kind: 'direct-iframe' },
    embed: { kind: 'direct-iframe', fixed: {}, iframePath: '/external-widgets/indices/kpow-broadcast' },
    fullscreenUrl: 'https://kalshi.com/charts/broadcast/kpow',
    dataSource: {
        summary: 'The broadcast view renders the same American Power Index feed as the standard chart.',
        requests: KPOW_REQUESTS,
        notes: [
            'history requires start_ts (unix seconds) and returns hourly points; the request 400s without it.',
            'The window is capped at 5000 hours, roughly 208 days.',
        ],
    },
};
